export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "stream_worker.de5f23ba.worker.js");
}
